module.exports = __webpack_public_path__ + "img/public-folder-icon-2.ccdcbb8b.svg";